import { render, staticRenderFns } from "./costlossMonthManage.vue?vue&type=template&id=0d47268e"
import script from "./costlossMonthManage.vue?vue&type=script&lang=js"
export * from "./costlossMonthManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d47268e')) {
      api.createRecord('0d47268e', component.options)
    } else {
      api.reload('0d47268e', component.options)
    }
    module.hot.accept("./costlossMonthManage.vue?vue&type=template&id=0d47268e", function () {
      api.rerender('0d47268e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/costloss/costlossMonthManage.vue"
export default component.exports